import type { FC } from 'react'
import { APP_VERSION } from '../../config/Config'
import { ContentContainer } from '../ContentContainer/ContentContainer'
import './styles.css'

const Footer: FC = () => {
  return (
    <footer className="footer-component">
      <div className="footer-banner">
        <ContentContainer>
          <div className="footer-general-info">
            <span>© BMW AG {new Date().getFullYear()}</span>
            <span>Version {APP_VERSION}</span>
          </div>
        </ContentContainer>
      </div>
    </footer>
  )
}

export default Footer
